import request from '@/utils/request'

/** 订单板块 订单重构新版 *********************************************************************/

/** 退订板块 2023-01-17 *********************************************************************/

// 退订订单详情
export function getUserRefundOrderDetal (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/refund/order/detail`, { params: params })
}
// 退订订单
export function orderRefundById (params = {}) {
  return request.post(`${process.env.ORDER_MODULE}/user/refund/order/refund`, params)
}
// 退订订单组详情
export function getUserRefundOrderShareDetal (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/refund/order-share/detail`, { params: params })
}
// 退订订单组
export function orderRefundByOrderShareId (params = {}) {
  return request.post(`${process.env.ORDER_MODULE}/user/refund/order-share/refund`, params)
}

// 获取退订信息
export function fetchOrderRefundInfo (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/refund/order/track`, { params: params })
}

/** 支付板块 2023-01-17 *********************************************************************/
// 支付宝支付
export function alipayOrderPayment (params = {}) {
  return request.post(`${process.env.ORDER_MODULE}/user/trade/alipay/order-payment`, params)
}
// 微信H5支付
export function wechatPayOrderPayment (params = {}) {
  return request.post(`${process.env.ORDER_MODULE}/user/trade/wechat-pay/order-authority`, params)
}
// 微信H5支付(openId版本)
export function wechatPayOrderPaymentByOpenId (params = {}) {
  return request.post(`${process.env.ORDER_MODULE}/user/trade/wechat-pay/order-web-payment`, params)
}
// 加密jwt
export function encodeJwt (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/encode/jwt`, params)
}
// 解密jwt
export function decodeJwt (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/decode/jwt`, { params: params })
}

/** 用户订单板块 2023-01-17 *********************************************************************/
// 获取订单组详情
export function fetchOrderDetailShareInfo (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/order/share/order-detail?orderShareId=${params.orderShareId}`)
}
// 订单组列表
export function fetchShareOrderList (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/order/share/order-collection`, { params: params })
}

// 订单分页列表
export function fetchSharePage (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/order/share/order-page`, { params: params })
}
// 取消订单
export function deleteCancelOrder (params = {}) {
  return request.delete(`${process.env.ORDER_MODULE}/user/order/order/cancel?orderId=${params.orderId}`)
}
// 删除订单
export function createOrderHide (params = {}) {
  return request.delete(`${process.env.ORDER_MODULE}/user/order/order/delete`, { params: params })
}

/** 下单板块 2023-01-17 *********************************************************************/
// 创建订单接口
export function createOrderApi (params = {}) {
  return request.post(`${process.env.ORDER_MODULE}/user/order/order/create`, params)
}
// 执行改签
export function createOrderTransferApi (params = {}) {
  return request.post(`${process.env.ORDER_MODULE}/user/transfer/transfer/transfer`, params)
}

// 获取团期详情
export function fetchCreateTripApi (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/trip/trip/detail`, { params: params })
}
// 紧急联系人获取
export function fetchCreateEmergencyApi () {
  return request.get(`${process.env.ORDER_MODULE}/user/account/account/emergency-user`)
}

// 获取出行人以及优惠权益列表V2
export function fetchUserDiscountOption (params = {}) {
  return request.post(`${process.env.ORDER_MODULE}/user/discount/discount/discount-option`, params)
}

// 出行人列表获取
export function fetchAccountContactListApi (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/account/account/contact-list`, { params: params })
}
// 批量获取出行人优惠权益
export function fetchUserDiscountApi (params = {}) {
  return request.post(`${process.env.ORDER_MODULE}/user/discount/discount/user-discount`, params)
}

/** 订单1.0 订单老版本 *************************************************************************/

// 订单组查询
export function fetchOrderShareInfo (params = {}) {
  return request.get(`${process.env.ORDER_URL}/order/details/${params.shareId}`)
}
// 人工退订
export function editRefundOrderIdLeaveNew (params = {}) {
  return request.put(`${process.env.ORDER_URL}/order/${params.refundOrderId}/leaveNew`, params)
}
// 统计退订理由借口
export function createRefundReason (params = {}) {
  return request.post(`${process.env.ORDER_URL}/order/${params.orderId}/refund-reason`, params)
}
// 删除订单
export function deleteOrder (params = {}) {
  return request.delete(`${process.env.ORDER_URL}/order/${params.orderId}`)
}
// 退订订单预操作微旅行
export function deleteOrderWeRefund (params = {}) {
  return request.delete(`${process.env.ORDER_URL}/order/werefund/${params.orderId}`)
}
// 退订订单预操作 （显示退款提示）
export function fetchOrderLeaveAmountNew (params = {}) {
  return request.get(`${process.env.ORDER_URL}/order/${params.orderId}/leaveAmountNew`)
}
// 取消 退订 预操作
export function fetchOrderBeforeCancelRefund (params = {}) {
  return request.get(`${process.env.ORDER_URL}/order/${params.orderId}/beforeCancelRefund`)
}
// 取消 退订
export function editRefundReason (params = {}) {
  return request.put(`${process.env.ORDER_URL}/order/${params.orderId}/cancelRefund`, params)
}
// 获取退款规则
export function fetchOrderAliasTransferRule (params = {}) {
  return request.get(`${process.env.ORDER_URL}/trip/${params.alias}/transferRule`)
}

// 通过orderId获取退款规则
export function fetchUserOrderRefundRule (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/refund/order/refund-rule`, { params: params })
}

/** 改签地址 *********************************************************************/
// 改签信息  这个应该在订单
export function deleteOrderCancelTransfer (params = {}) {
  return request.delete(`${process.env.ORDER_MODULE}/user/transfer/transfer/cancel`, { params: params })
}

// 订单组内可改签订单列表
export function fetchShareIdApplyTransfer (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/transfer/order/order-list`, { params: params })
}

// 获取可以改签至的指定路线的团期列表
export function fetchTransferRouteTripList (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/transfer/transfer/trip-list`, { params: params })
}

// 获取能改签的业务类型
export function fetchTransferGatherCatalog (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/transfer/transfer/gather-catalog`, { params: params })
}

// 可改签的其他路线列表
export function fetchTransferSkuList (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/transfer/transfer/sku-list`, { params: params })
}

// 改签前检查
export function fetchOrderConfirmTransfer (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/transfer/transfer/pre-check`, { params: params })
}

// 获取只包含护照信息的改签订单列表
export function fetchOrderPassportOrderList (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/transfer/order/passport-order-list`, { params: params })
}

// 国内转国际团需要补足护照等信息
export function editTransferFillOrderPassport (params = {}) {
  return request.put(`${process.env.ORDER_MODULE}/user/transfer/order/fill-order-passport`, params, {
    axiosCustomConfig: {
      startLoading: true
    }
  })
}

// 补充订单港澳通行证数据
export function editTransferFillOrderHkMcao (params = {}) {
  return request.put(`${process.env.ORDER_MODULE}/user/transfer/order/fill-hk-mao-permit-order`, params, {
    axiosCustomConfig: {
      startLoading: true
    }
  })
}

// 获取只包含港澳台出行证的改签订单列表
export function fetchOrderHkMaoPermitOrderList (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/transfer/order/hk-mao-permit-order-list`, { params: params })
}

// 改签支付页面
export function fetchUserTransferInfo (params = {}) {
  return request.get(`${process.env.ORDER_MODULE}/user/transfer/transfer/info`, { params: params })
}

// 改签支付页面
export function fetchUserDivisionCountry (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/administration/division/country`, { params: params })
}

/** 预售板块 *********************************************************************/
// 预售退订
export function editReserveLeaveAmountNewReserve (params = {}) {
  return request.put(`${process.env.ORDER_URL}/order/${params.refundReserveId}/leaveAmountNewReserve`, params)
}
// 预售退订信息
export function fetchReserveLeaveAmountNewReserve (params = {}) {
  return request.get(`${process.env.ORDER_URL}/order/${params.reserveId}/leaveAmountNewReserve`)
}
// 预售订单列表
export function fetchReserveList () {
  return request.get(`${process.env.ORDER_URL}/order/reserveList/normal`)
}

// 选择出行人提交订单
export function createOrderTripApi (params = {}) {
  return request.post(`${process.env.ORDER_URL}/order/create/${params.tripOriginalId}`, params)
}

// 选择出行人提交订单页面接口
export function fetchOrderDiscountsInfo (params = {}) {
  return request.get(`${process.env.ORDER_URL}/order/discounts/${params.orderIds}`, { params: params })
}

// 用户提交订单
export function createOrderCoupon (params = {}) {
  return request.post(`${process.env.ORDER_URL}/order/useOrderCoupon`, params)
}

/** 下单板块 *********************************************************************/

// 申请退订详情接口
export function fetchOrderPreviewRefundInfo (params = {}) {
  return request.get(`${process.env.ORDER_API}/order/${params.orderId}/preview-refund`)
}
// 队员取消疫情凭证申请
export function updateOrderEpidemicEvidenceIdStatus (params = {}) {
  params.status = 'CANCEL'
  return request.put(`${process.env.ORDER_API}/order/epidemic/evidence/${params.orderEpidemicEvidenceId}/update-status`, params)
}
// 创建疫情凭证接口
export function createOrderEpidemicEvidence (params = {}) {
  return request.post(`${process.env.ORDER_API}/order/epidemic/evidence`, params)
}
// 疫情凭证申请详情接口
export function fetchOrderEpidemicEvidenceId (params = {}) {
  return request.get(`${process.env.ORDER_API}/order/epidemic/evidence/${params.orderId}`, params)
}
// 更新疫情凭证接口
export function updateOrderEpidemicEvidenceId (params = {}) {
  params.status = 'CANCEL'
  return request.put(`${process.env.ORDER_API}/order/epidemic/evidence/${params.orderEpidemicEvidenceId}`, params)
}



// WEBPACK FOOTER //
// ./src/api/order/order.js